import 'core-js/stable'
import 'regenerator-runtime/runtime'
import VideoTimeline from './videoTimeline/index.js'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/tailwind.css'
import './assets/css/theme.css'
// 导入 Vant UI 组件
import Vant from 'vant'
import 'vant/lib/index.css'

// 导入 FontAwesome 图标
import '@fortawesome/fontawesome-free/css/all.min.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faHome } from '@fortawesome/free-solid-svg-icons/faHome'
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons/faMapMarkerAlt'
import { faRobot } from '@fortawesome/free-solid-svg-icons/faRobot'
import { faMicrochip } from '@fortawesome/free-solid-svg-icons/faMicrochip'
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser'
import { faSatellite } from '@fortawesome/free-solid-svg-icons/faSatellite'
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch'
import { faTachometerAlt } from '@fortawesome/free-solid-svg-icons/faTachometerAlt'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle'
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner'
import { faLocationArrow } from '@fortawesome/free-solid-svg-icons/faLocationArrow'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft'
import { faHospital } from '@fortawesome/free-solid-svg-icons/faHospital'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons/faChevronLeft'
import { faImage } from '@fortawesome/free-solid-svg-icons/faImage'
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons/faPaperPlane'
import { faClock } from '@fortawesome/free-solid-svg-icons/faClock'
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons/faTimesCircle'
import { faThermometerHalf } from '@fortawesome/free-solid-svg-icons/faThermometerHalf'
import { faStore } from '@fortawesome/free-solid-svg-icons/faStore'
import { faComments } from '@fortawesome/free-solid-svg-icons/faComments'
import { faPhone } from '@fortawesome/free-solid-svg-icons/faPhone'
import { faPaw } from '@fortawesome/free-solid-svg-icons/faPaw'
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons/faPlusCircle'
import { faCrown } from '@fortawesome/free-solid-svg-icons/faCrown'
import { faQrcode } from '@fortawesome/free-solid-svg-icons/faQrcode'
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes'
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons/faQuestionCircle'
import { faShieldAlt } from '@fortawesome/free-solid-svg-icons/faShieldAlt'
import { faHistory } from '@fortawesome/free-solid-svg-icons/faHistory'
import { faCog } from '@fortawesome/free-solid-svg-icons/faCog'
import { faHeadset } from '@fortawesome/free-solid-svg-icons/faHeadset'
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons/faSignOutAlt'
import { faWifi } from '@fortawesome/free-solid-svg-icons/faWifi'
import { faSignal } from '@fortawesome/free-solid-svg-icons/faSignal'
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck'
import { faFire } from '@fortawesome/free-solid-svg-icons/faFire'
import { faShoePrints } from '@fortawesome/free-solid-svg-icons/faShoePrints'
import { faWalking } from '@fortawesome/free-solid-svg-icons/faWalking'
import { faRunning } from '@fortawesome/free-solid-svg-icons/faRunning'
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons/faCalendarAlt'
import { faDog } from '@fortawesome/free-solid-svg-icons/faDog'
import { faCat } from '@fortawesome/free-solid-svg-icons/faCat'
import { faUtensils } from '@fortawesome/free-solid-svg-icons/faUtensils'
import { faMoon } from '@fortawesome/free-solid-svg-icons/faMoon'
import { faCamera } from '@fortawesome/free-solid-svg-icons/faCamera'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown'
import { faPlay } from '@fortawesome/free-solid-svg-icons/faPlay'
import { faBell } from '@fortawesome/free-solid-svg-icons/faBell'
import { faVolumeUp } from '@fortawesome/free-solid-svg-icons/faVolumeUp'
import { faUnlink } from '@fortawesome/free-solid-svg-icons/faUnlink'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle'
import { faClipboard,faThList, faSyringe, faBug, faStethoscope, faBriefcaseMedical,
  faYenSign, faPaperclip, faEye, faWeight, faNotesMedical,faEdit, faTrashAlt, faPlayCircle
 } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// 添加图标到库
library.add(
  faHome, faMapMarkerAlt, faRobot, faMicrochip, faUser,
  faSatellite, faSearch, faTachometerAlt, faInfoCircle,
  faSpinner, faLocationArrow, faArrowLeft, faHospital,
  faChevronRight, faChevronLeft, faImage, faPaperPlane, faClock,
  faTimesCircle, faThermometerHalf, faStore, faComments,
  faLocationArrow, faPhone, faPaw, faPlusCircle,
  faCrown, faQrcode, faTimes, faQuestionCircle,
  faShieldAlt, faHistory, faCog, faHeadset, 
  faSignOutAlt, faWifi, faSignal, faCheck, faFire,
  faShoePrints, faWalking, faRunning, faCalendarAlt,
  faDog, faCat, faUtensils, faMoon, faCamera, faChevronDown, faPlay,
  faBell, faVolumeUp, faUnlink, faExclamationTriangle, faCheckCircle,faClipboard,faThList, 
  faSyringe, faBug, faStethoscope, faBriefcaseMedical,faYenSign, faPaperclip, faEye, faWeight, faNotesMedical,
  faEdit, faTrashAlt, faPlayCircle 
)

// 注册全局组件
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(VideoTimeline)
// 使用 Vant UI
Vue.use(Vant)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app') 